<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>

<template>
  <div>
    <div class="echarts" :id="id" ref="echarts-bar"></div>
  </div>
</template>

<script>
export default {
  name: "echarts",
  props: {
    radarData: {
      type: Object,
      default() {
        return {};
      }
    },
    radar: {
      type: Array,
      default() {
        return [];
      }
    },
    areaData: {
      type: Array,
      default() {
        return [];
      }
    },
    id: String
  },
  data() {
    return {};
  },
  watch: {
    radarData() {
      this.createEcharts();
    },
    radar() {
      this.createEcharts();
    },
    areaData() {
      this.createEcharts();
    }
  },
  mounted() {
    this.createEcharts();
  },
  methods: {
    createEcharts() {
      let $echartsDOM = document.getElementById(this.id);
      let myEcharts = this.$echarts.init($echartsDOM);
      let defaultData, villageContrastData,areaContrastData;
      if (this.radar.length>0) {
        if (this.radar.length == 2) {
          villageContrastData = [
            {
              value: [
                this.radar[0].score,
                this.radar[0].recreation,
                this.radar[0].life,
                this.radar[0].shopping,
                this.radar[0].traffic
              ],
              itemStyle: {
                normal: {
                  color: "#4169E1"
                }
              },
              lineStyle: {
                width: 1,
                color: "#4169E1"
              }
            },
            {
              value: [
                this.radar[1].score,
                this.radar[1].recreation,
                this.radar[1].life,
                this.radar[1].shopping,
                this.radar[1].traffic
              ],
              itemStyle: {
                normal: {
                  color: "#4ACAA8"
                }
              },
              lineStyle: {
                width: 1,
                color: "#4ACAA8"
              }
            }
          ];
        } else if (this.radar.length == 1) {
          villageContrastData=[
            {
              value: [
                this.radar[0].score,
                this.radar[0].recreation,
                this.radar[0].life,
                this.radar[0].shopping,
                this.radar[0].traffic
              ],
              itemStyle: {
                normal: {
                  color: "#4169E1"
                }
              },
              lineStyle: {
                width: 1,
                color: "#4169E1"
              }
            }
          ]
        }else{
          villageContrastData = [
            {
              value: [
                this.radar[2].score,
                this.radar[2].recreation,
                this.radar[2].life,
                this.radar[2].shopping,
                this.radar[2].traffic
              ],
              itemStyle: {
                normal: {
                  color: "#F5A623"
                }
              },
              lineStyle: {
                width: 1,
                color: "#F5A623"
              }
            },
            {
              value: [
                this.radar[0].score,
                this.radar[0].recreation,
                this.radar[0].life,
                this.radar[0].shopping,
                this.radar[0].traffic
              ],
              itemStyle: {
                normal: {
                  color: "#4169E1"
                }
              },
              lineStyle: {
                width: 1,
                color: "#4169E1"
              }
            },
            {
              value: [
                this.radar[1].score,
                this.radar[1].recreation,
                this.radar[1].life,
                this.radar[1].shopping,
                this.radar[1].traffic
              ],
              itemStyle: {
                normal: {
                  color: "#4ACAA8"
                }
              },
              lineStyle: {
                width: 1,
                color: "#4ACAA8"
              }
            }
          ];
        }
      } else if (this.areaData.length>0) {
        if (this.areaData.length == 2) {
          areaContrastData = [
            {
              value: [
                this.areaData[0].brandPremium,
                this.areaData[0].rentPriceIncrement,
                this.areaData[0].marketVolume,
                this.areaData[0].houseFlow
              ],
              itemStyle: {
                normal: {
                  color: "#4169E1"
                }
              },
              lineStyle: {
                width: 1,
                color: "#4169E1"
              }
            },
            {
              value: [
                this.areaData[1].brandPremium,
                this.areaData[1].rentPriceIncrement,
                this.areaData[1].marketVolume,
                this.areaData[1].houseFlow
              ],
              itemStyle: {
                normal: {
                  color: "#4ACAA8"
                }
              },
              lineStyle: {
                width: 1,
                color: "#4ACAA8"
              }
            }
          ];
        } else if (this.areaData.length == 1) {
          areaContrastData = [
            {
              value: [
                this.areaData[0].brandPremium,
                this.areaData[0].rentPriceIncrement,
                this.areaData[0].marketVolume,
                this.areaData[0].houseFlow
              ],
              itemStyle: {
                normal: {
                  color: "#4169E1"
                }
              },
              lineStyle: {
                width: 1,
                color: "#4169E1"
              }
            }]
        }else{
          areaContrastData = [
            {
              value: [
                this.areaData[2].brandPremium,
                this.areaData[2].rentPriceIncrement,
                this.areaData[2].marketVolume,
                this.areaData[2].houseFlow
              ],
              itemStyle: {
                normal: {
                  color: "#F5A623"
                }
              },
              lineStyle: {
                width: 1,
                color: "#F5A623"
              }
            },
            {
              value: [
                this.areaData[0].brandPremium,
                this.areaData[0].rentPriceIncrement,
                this.areaData[0].marketVolume,
                this.areaData[0].houseFlow
              ],
              itemStyle: {
                normal: {
                  color: "#4169E1"
                }
              },
              lineStyle: {
                width: 1,
                color: "#4169E1"
              }
            },
            {
              value: [
                this.areaData[1].brandPremium,
                this.areaData[1].rentPriceIncrement,
                this.areaData[1].marketVolume,
                this.areaData[1].houseFlow
              ],
              itemStyle: {
                normal: {
                  color: "#4ACAA8"
                }
              },
              lineStyle: {
                width: 1,
                color: "#4ACAA8"
              }
            }
          ];
        }
      } else{
        defaultData = [
          {
            value: [
              this.radarData.brandPremium,
              this.radarData.rentPriceIncrement,
              this.radarData.marketVolume,
              this.radarData.houseFlow
            ],
            itemStyle: {
              normal: {
                color: "#0039FF"
              }
            },
            lineStyle: {
              width: 1,
              color: "#0039FF"
            }
          }
        ];
      }
      let option = {
        backgroundColor: "#ffffff",
        color: ["#37A2DA", "#FF9F7F"],
        tooltip: {},
        xAxis: {
          show: false
        },
        yAxis: {
          show: false
        },
        radar: {
          // shape: 'circle',
          name: {
            textStyle: {
              color: "#89939F",
              formatter: "{score|{value}}",
              rich: {
                score: {
                  fontSize: 13
                }
              }
            }
          },
          axisLine: {
            lineStyle: {
              type: "dashed"
            }
          },
          indicator:
            this.id == "village-contrast-radar"
              ? [
                  {
                    name: "步行指数",
                    max: 100
                  },
                  {
                    name: "娱乐",
                    max: 100
                  },
                  {
                    name: "生活",
                    max: 100
                  },
                  {
                    name: "购物",
                    max: 100
                  },
                  {
                    name: "交通",
                    max: 100
                  }
                ]
              : [
                  {
                    name: "公寓溢价",
                    max: 100
                  },
                  {
                    name: "租金涨势",
                    max: 100
                  },
                  {
                    name: "市场体量",
                    max: 100
                  },
                  {
                    name: "房源流转",
                    max: 100
                  }
                ]
        },
        series: [
          {
            name:
              this.id == "village-contrast-radar" ? "步行指数" : "各评分项分布",
            type: "radar",
            lineStyle: {
              color: "#4169E1"
            },
            areaStyle: {
              opacity: 0.5
            },
            data:
              this.id == "village-contrast-radar"
                ? villageContrastData:this.id == "contrast-radar"?areaContrastData
                : defaultData
          }
        ]
      };
      myEcharts.setOption(option);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/echarts_radar/index.vue